import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';

export default function Profile() {
  const { user, profile, refreshProfile } = useAuth();
  const [form, setForm]   = useState({ displayName: '', phone: '' });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved]   = useState(false);

  useEffect(() => {
    if (profile) {
      setForm({
        displayName: profile.displayName || '',
        phone:       profile.phone       || ''
      });
    }
  }, [profile]);

  async function save(e) {
    e.preventDefault();
    setSaving(true); setSaved(false);
    try {
      // Update the Supabase Auth user metadata (display name).
      await supabase.auth.updateUser({
        data: { display_name: form.displayName }
      });

      // Update the public.users profile row.
      const { error } = await supabase
        .from('users')
        .update({
          display_name: form.displayName,
          phone:        form.phone,
          updated_at:   new Date().toISOString()
        })
        .eq('id', user.id);

      if (error) throw error;

      await refreshProfile(user);
      setSaved(true);
    } catch (err) {
      console.error('[Profile] save failed:', err.message);
    } finally { setSaving(false); }
  }

  if (!profile) return <div className="p-8 text-slate-500">Loading profile…</div>;

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-2xl font-semibold mb-6">My profile</h1>
      <form onSubmit={save} className="card p-6 space-y-4">
        <div>
          <label className="label">Email (read-only)</label>
          <input className="input bg-slate-50" value={profile.email} readOnly />
        </div>
        <div>
          <label className="label">Display name</label>
          <input
            className="input"
            value={form.displayName}
            onChange={e => setForm(f => ({ ...f, displayName: e.target.value }))}
            required
          />
        </div>
        <div>
          <label className="label">Phone</label>
          <input
            className="input"
            value={form.phone}
            onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
            placeholder="+254…"
          />
        </div>
        <div>
          <label className="label">Role</label>
          <input className="input bg-slate-50" value={profile.role} readOnly />
          <p className="text-xs text-slate-500 mt-1">Only an admin can change roles.</p>
        </div>
        <div className="flex items-center gap-3">
          <button disabled={saving} className="btn-primary">
            {saving ? 'Saving…' : 'Save changes'}
          </button>
          {saved && <span className="text-emerald-700 text-sm">Saved.</span>}
        </div>
      </form>
    </div>
  );
}
